module.exports = "/_next/static/images/game-2-menu-social-slide-1-aa18006c77b46a9fffdd42497e81b3ad.png";